import { createUseStyles, Styles } from '@pff-consumer/web-ui/styles'

interface CreateAccountErrorStyles {
  createAccountContainer: Styles
  button: Styles
}
export const useStyles = createUseStyles<CreateAccountErrorStyles>((theme) => {
  return {
    createAccountContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.calcUnit(theme.spacing.s5),
    },
    button: {
      marginTop: theme.calcUnit(theme.spacing.s1),
    },
  }
})
